/**
 * General utilties for the timeline html definition
 */
class TimelineHtmlUtils {

    private static readonly TIMELINE_ITEM_CLASS = 'ametras-timeline__item';
    private static readonly TIMELINE_ITEM_TOOLTIP_PAIR =
        '<div class="ametras-timeline__item__info-pair">' +
        '<span class="font-weight-bold">%LEFT%</span>' +
        '<span>%RIGHT%</span>' +
        '</div>';
    private static readonly TIMELINE_ITEM_TOOLTIP_PAIR_MULTILINE =
        '<div class="ametras-timeline__item__info-pair ametras-timeline__item__info-pair--vertical">' +
        '<div class="font-weight-bold">%UP%</div>' +
        '<div>%DOWN%</div>' +
        '</div>';
    private static readonly TIMELINE_ITEM_TOOLTIP_PAIRS_WRAPPER =
        '<div class="ametras-timeline__item__info %OPTIONALCLASS%">' +
        '%CONTENT%' +
        '</div>';

    getTimelineItemClass(modifier: string, customClass: string) {
        let result = TimelineHtmlUtils.TIMELINE_ITEM_CLASS + ' ';
        if (modifier) {
            result += TimelineHtmlUtils.TIMELINE_ITEM_CLASS + '--' + modifier + ' ';
        }
        return result + customClass;
    }

    createTimelineItemTooltipPair(left: string, right: string) {
        return TimelineHtmlUtils.TIMELINE_ITEM_TOOLTIP_PAIR
            .replace('%LEFT%', left)
            .replace('%RIGHT%', right);
    }

    createTimelineItemTooltipPairMultiline(up: string, down: string) {
        return TimelineHtmlUtils.TIMELINE_ITEM_TOOLTIP_PAIR_MULTILINE
            .replace('%UP%', up)
            .replace('%DOWN%', down);
    }

    createTimelineItemTooltipPairsWrapper(content: string, optionalClass?: string) {
        return TimelineHtmlUtils.TIMELINE_ITEM_TOOLTIP_PAIRS_WRAPPER
            .replace('%CONTENT%', content)
            .replace('%OPTIONALCLASS%', optionalClass || '');
    }
}

const TIMELINE_HTML_UTILS_INSTANCE = new TimelineHtmlUtils();

export {TIMELINE_HTML_UTILS_INSTANCE};
